enum TrackersTabs {
  Quality = 'quality',
  Performance = 'performance',
  Sustainability = 'sustainability',
}

export default TrackersTabs;
